import { useState, useEffect, useRef } from "react";

/* ═══════════════════════════════════════════════════════════════
   SOCIAL PROOF — Homepage Reviews (Shopify-focused, 10 reviews)
   Design matches services/shopify-development review section
   ═══════════════════════════════════════════════════════════════ */

const REVIEWS = [
  {
    text: "TechTCL didn't just redesign our store — they engineered a system that increased our conversion rate by 42% in just only three months. The ROI on this project paid for itself within a weeks.",
    name: "Sarah Mitchell",
    role: "E-commerce Director",
    company: "54 Thrones",
    result: "+42% conversions",
    avatar:
      "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/young-girl-checked-shirt-pink-t-shirt-standing-arms-crossed-looking-happy.jpg?v=1775024896&width=200",
  },
  {
    text: "Working with TechTCL was a game-changer. They understood our subscription model deeply and built a quiz flow that our customers actually love. Our subscriber LTV jumped significantly.",
    name: "James Cooper",
    role: "Founder & CEO",
    company: "Wuffes",
    result: "2× subscription revenue",
    avatar:
      "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/Male2.webp?v=1775023893&width=200",
  },
  {
    text: "TechTCL handled our custom Shopify features flawlessly. Even the complex requirements were delivered smoothly and exactly as we needed. Our store now loads faster and creates a better experience for customers.",
    name: "Ayesha Malik",
    role: "Founder",
    company: "Kristaline Jewelary",
    result: "+35% page speed",
    avatar:
      "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/expressive-young-woman-posing.jpg?v=1775023972&width=200",
  },
  {
    text: "They redesigned our homepage, improved the UI/UX, and fixed several technical issues. The site now looks far more professional and trustworthy. They guided us every step with helpful suggestions.",
    name: "Jonathan Price",
    role: "Brand Owner",
    company: "Nestly",
    result: "+48% trust score",
    avatar:
      "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/headshot-attractive-curly-youngster-looks-seriously-camera.jpg?v=1775024216&width=200",
  },
  {
    text: "TechTCL brought our Shopify store to a whole new level. They improved our product pages, refined the layout, and made the entire site feel much more premium. Great work and truly reliable service.",
    name: "Ethan Walker",
    role: "Founder & CEO",
    company: "EX Bike",
    result: "+61% mobile revenue",
    avatar:
      "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/Male4.webp?v=1775023892&width=200",
  },
  {
    text: "He goes way beyond boundaries to help you solve any problem. The attention to detail in the Liquid code and the strategic thinking behind every design decision — that's rare to find.",
    name: "Michelle Park",
    role: "Head of Digital",
    company: "Bird&Be",
    result: "78% quiz completion",
    avatar:
      "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/Male7.webp?v=1775023892&width=200",
  },
  {
    text: "We tried three other developers before finding TechTCL. The difference? They think like a business owner, not just a coder. Our landing page CVR from paid ads went up 56%.",
    name: "David Chen",
    role: "Marketing Director",
    company: "CRVY",
    result: "+56% landing page CVR",
    avatar:
      "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/Male1.png?v=1775024372&width=200",
  },
  {
    text: "Our Shopify Plus migration was flawless. Zero downtime, every feature preserved, and they even optimized our checkout flow during the transition. Couldn't have asked for more.",
    name: "Rachel Kim",
    role: "VP of E-commerce",
    company: "LuxeHome Co.",
    result: "Zero downtime migration",
    avatar:
      "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/Male5.png?v=1775024372&width=200",
  },
  {
    text: "TechTCL approached our Shopify build with exceptional taste and precision. Every detail from layout to performance felt intentional. The final result reflects a refined brand experience.",
    name: "Alessandro Rinaldi",
    role: "Founder",
    company: "Boutique Lifestyle Brand",
    result: "95+ PageSpeed score",
    avatar:
      "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/Male6.png?v=1775024372&width=200",
  },
  {
    text: "If you want a Shopify agency that understands what actually drives sales, TechTCL is it. Every decision they made was intentionally measurable. Our new store is a conversion machine.",
    name: "Marcus Bennett",
    role: "Marketing Lead",
    company: "Retail Brand",
    result: "+38% overall CVR",
    avatar:
      "https://cdn.shopify.com/s/files/1/0644/4086/0781/files/Male3.webp?v=1775023893&width=200",
  },
];

export default function SocialProof() {
  const [active, setActive] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const timerRef = useRef(null);

  // Auto-rotate
  useEffect(() => {
    timerRef.current = setInterval(() => {
      setActive((p) => (p + 1) % REVIEWS.length);
    }, 5000);
    return () => clearInterval(timerRef.current);
  }, []);

  const goTo = (i) => {
    setActive(i);
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setActive((p) => (p + 1) % REVIEWS.length);
    }, 5000);
  };

  const goPrev = () => goTo((active - 1 + REVIEWS.length) % REVIEWS.length);
  const goNext = () => goTo((active + 1) % REVIEWS.length);

  // Intersection Observer
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.15 },
    );
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      className="social-proof-main"
      ref={sectionRef}
      style={{
        padding: "90px 20px",
        background: "linear-gradient(135deg, #2563eb 0%, #1e3c72 100%)",
        position: "relative",
        overflow: "hidden",
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(30px)",
        transition: "all 0.8s ease",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,.05)",
          zIndex: 0,
        }}
      />

      <div
        style={{
          maxWidth: 860,
          margin: "0 auto",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <span
            style={{
              fontSize: 12,
              letterSpacing: 3,
              color: "rgba(255,255,255,.4)",
              textTransform: "uppercase",
              fontWeight: 700,
            }}
          >
            CLIENT REVIEWS
          </span>
          <h2
            className="cr-credibility-title"
            style={{
              fontSize: "clamp(28px,4vw,42px)",
              color: "#fff",
              marginTop: 8,
              lineHeight: 1.2,
            }}
          >
            What Our Clients Say About
            <br /> Working With TechTCL
          </h2>
        </div>

        {/* Review Card */}
        <div style={{ position: "relative", minHeight: 280 }}>
          {REVIEWS.map((review, i) => (
            <div
              className="cs-review-card"
              key={i}
              style={{
                position: i === active ? "relative" : "absolute",
                top: 0,
                left: 0,
                right: 0,
                opacity: i === active ? 1 : 0,
                transform: i === active ? "translateY(0)" : "translateY(15px)",
                transition: "all .6s ease",
                pointerEvents: i === active ? "auto" : "none",
                background: "rgba(255,255,255,.08)",
                borderRadius: 22,
                border: "1px solid rgba(255,255,255,.12)",
                padding: "44px 40px",
                backdropFilter: "blur(10px)",
              }}
            >
              {/* Stars */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 4,
                  // marginBottom: 20,
                }}
              >
                {[...Array(5)].map((_, j) => (
                  <span key={j} style={{ color: "#F5D060", fontSize: 20 }}>
                    ★
                  </span>
                ))}
              </div>

              {/* Quote */}
              <p
                style={{
                  fontSize: "clamp(14px,2vw,18px)",
                  fontStyle: "italic",
                  lineHeight: 1.8,
                  color: "#fff",
                  marginBottom: 28,
                  textAlign: "center",
                  maxWidth: 680,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                "{review.text}"
              </p>

              {/* Attribution */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 16,
                }}
              >
                <div className="sp-review-image"
                  style={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%",
                    background: "rgba(96,165,250,.15)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#60a5fa",
                    border: "2px solid rgba(96,165,250,.3)",
                    overflow: "hidden",
                    objectFit: "cover",
                  }}
                >
                  {/* {review.name
                    .split(" ")
                    .map((w) => w[0])
                    .join("")} */}
                  <img style={{width: "100%", height: "100%"}} src={review.avatar} alt={review.name} />
                </div>
                <div style={{ textAlign: "left" }}>
                  <div style={{ fontSize: 15, fontWeight: 700, color: "#fff" }}>
                    {review.name}
                  </div>
                  <div style={{ fontSize: 12, color: "rgba(255,255,255,.5)" }}>
                    {review.role}, {review.company}
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      color: "#60a5fa",
                      fontWeight: 600,
                      marginTop: 2,
                    }}
                  >
                    Result: {review.result}
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* Arrows */}
          <button
            onClick={goPrev}
            style={{
              position: "absolute",
              left: -20,
              top: "50%",
              transform: "translateY(-50%)",
              width: 42,
              height: 42,
              borderRadius: "50%",
              background: "rgba(255,255,255,.1)",
              border: "1px solid rgba(255,255,255,.2)",
              color: "#fff",
              fontSize: 20,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all .3s",
              backdropFilter: "blur(6px)",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = "rgba(255,255,255,.2)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "rgba(255,255,255,.1)")
            }
          >
            ‹
          </button>
          <button
            onClick={goNext}
            style={{
              position: "absolute",
              right: -20,
              top: "50%",
              transform: "translateY(-50%)",
              width: 42,
              height: 42,
              borderRadius: "50%",
              background: "rgba(255,255,255,.1)",
              border: "1px solid rgba(255,255,255,.2)",
              color: "#fff",
              fontSize: 20,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all .3s",
              backdropFilter: "blur(6px)",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = "rgba(255,255,255,.2)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "rgba(255,255,255,.1)")
            }
          >
            ›
          </button>
        </div>

        {/* Dots */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 6,
            marginTop: 28,
          }}
        >
          {REVIEWS.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              style={{
                width: i === active ? 28 : 8,
                height: 8,
                borderRadius: 8,
                border: "none",
                cursor: "pointer",
                background: i === active ? "#60a5fa" : "rgba(255,255,255,.2)",
                transition: "all .3s",
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
